// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"1e38b087","75":"6350a357","345":"8dc62c77","967":"8a228809"}[chunkId] + ".chunk.css";
};